import React from 'react';
import properties from '../../../modules/ajio-util/properties';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

class VimeoVideoCustomComponent extends React.Component {
  render() {
    const pagedetails = this.props.pagedetails;
    if (pagedetails === undefined) {
      return null;
    }
    return (
      <video width="100%" height="500" controls>
        <source src={replaceWithJioCDN(pagedetails.mobileCatAppUrl)} />
      </video>
    );
  }
}

export default BannerWrapper(VimeoVideoCustomComponent);
